<template>
  <div class="h-full">
    <Swiper :modules="modules" :pagination="true" :slides-per-view="1" class="h-full">
      <SwiperSlide>
        <img class="guide-img mt-4" src="@/assets/guides/property-list/welcome.webp" />
        <p class="guide-text mt-2">
          The <span class="font-bold">Properties Page</span> is more than just a list of your properties. It is a
          <span class="font-bold">dynamic tool</span> to <span class="font-bold">filter</span> and
          <span class="font-bold">sort</span>. Connection <span class="font-bold">status</span> can also be seen across
          <span class="font-bold">all</span> of your properties.
        </p>
      </SwiperSlide>
      <SwiperSlide>
        <img class="guide-img mt-4" src="@/assets/guides/property-list/property-tile.webp" />
        <p class="guide-text mt-2">
          Each <span class="font-bold">Property Row</span> includes icons for its Gateway's
          <span class="font-bold">connection status</span>. A <span class="font-bold">blue</span> Gateway icon indicates
          the Gateway is <span class="font-bold">connected</span> to the cloud. A
          <span class="font-bold">gray</span> Gateway icon means the Gateway is
          <span class="font-bold">not connected</span> to the cloud.
        </p>
      </SwiperSlide>
      <SwiperSlide>
        <img class="guide-img mt-4" src="@/assets/guides/property-list/filter-1.webp" />
        <p class="guide-text mt-4">
          Use the <span class="font-bold">Property Filter</span> for <span class="font-bold">narrowing</span> in on
          properties that meet a certain criteria. A few examples of <span class="font-bold">valuable</span> filter
          expressions could be:
        </p>
        <ul class="guide-text *:text-left *:pl-6 *:-indent-6 mt-4">
          <li class="mt-2">
            <i class="icon-check-circle mr-2 text-blue-500"></i>Show me properties within 20 miles of Dallas, TX.
          </li>
          <li class="mt-2">
            <i class="icon-check-circle mr-2 text-blue-500"></i>Show me properties with offline Gateways.
          </li>
          <li class="mt-2">
            <i class="icon-check-circle mr-2 text-blue-500"></i>Show me properties with open Leak alerts.
          </li>
        </ul>
        <img class="guide-text mt-2" src="@/assets/guides/property-list/filter-2.webp" />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';

const modules = [Pagination];
</script>

<style scoped>
.guide-img {
  @apply w-full max-w-[300px] md:max-w-[350px] mx-auto;
}
.guide-text {
  @apply w-[300px] max-w-[75%] mx-auto text-center text-gray-700 font-normal text-sm md:text-base;
}
</style>
